import React, { useEffect, useRef } from "react";

// Small confirmation dialog. `actions` render left-to-right as buttons:
// [{ label, variant: "outline" | "danger" | "primary", onClick }].
export default function ConfirmDialog({ title, message, actions, busy = false, onClose }) {
  const dialogRef = useRef(null);

  useEffect(() => {
    dialogRef.current?.focus();
    const handleKeyDown = (event) => {
      if (event.key === "Escape" && !busy) onClose();
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [busy, onClose]);

  return (
    <div className="ads-modal-backdrop ads-confirm-backdrop">
      <div
        ref={dialogRef}
        className="ads-modal ads-confirm"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="ads-confirm-title"
        aria-describedby="ads-confirm-message"
        tabIndex={-1}
      >
        <h2 id="ads-confirm-title">{title}</h2>
        <p id="ads-confirm-message">{message}</p>
        <div className="ads-modal-footer">
          {actions.map((action) => (
            <button
              key={action.label}
              type="button"
              className={`ads-button ads-button-${action.variant || "outline"}`}
              onClick={action.onClick}
              disabled={busy}
            >
              {action.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
